const __WEBPACK_NAMESPACE_OBJECT__ = require("react-chartjs-2");